/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockAdjustOutDtEditor extends Serenity.Extensions.GridEditorBase<IcStockAdjustOutDtRow> {
        protected getColumnsKey() { return "Inventory.IcStockAdjustOutDt"; }
        protected getDialogType() { return IcStockAdjustOutDtDialog; }
        protected getLocalTextPrefix() { return IcStockAdjustOutDtRow.localTextPrefix; }

        public qnNo: number;
        


        public myPassValue: string;
        public myPassValue2: number;
        constructor(container: JQuery) {
            super(container);
        
        }
      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text(" สร้างรายการ"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {
                        this.createEntityDialog(this.getItemType(), dlg => {


                            var dialog = dlg as IcStockAdjustOutDtDialog;
                            dialog.onSave = (opt, callback) => this.save(opt, callback);
                            var entity = this.getNewEntity() as IcStockAdjustOutDtRow;

                            entity.SysDocNo = this.myPassValue;
                            entity.AdjFg = this.AdjFg;
                            if (this.myPassValue2 == 1) {
                                entity.Id = -1;
                            }



                            dialog.loadEntityAndOpenDialog(entity, false);
                        });
                    },
                }
            );
            
            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }
        validateEntity(row, id) {
             row.PurUnitPrice = (row.CostValue || 0) / (row.Qty || 1);
            row.UnitCost = (row.CostValue || 0 ) / ((row.Qty || 1) * (row.PurUnitRatio));
            return true;
        }
   
    

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            //--set new set of grid columns---
            //--get content width
            let ele = document.getElementsByClassName("grid-container");
            var bordermg = 60;
            var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            var totalcolw = 0;

            let propItems = this.getPropertyItems();
            let items = this.getColumns();
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                totalcolw += pItem.width;

            });
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                pItem.resizable = true;
                pItem.width = (eleWidth / totalcolw) * pItem.width;


            });

            let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            grid.setColumns(c);
            grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    //new Slick.Aggregators.Sum('PurUnitRatio'),
                    //new Slick.Aggregators.Sum('PurUnitPrice'),
                    //new Slick.Aggregators.Sum('UnitCost'),
                    new Slick.Aggregators.Sum('CostValue')
                ]
            });
            return grid;
        }

        private _AdjFg: number;
        public get AdjFg(): number { return this._AdjFg; }

        set AdjFg(value: number) {
            this._AdjFg = value || 0;
            var row = this.view.getRows();
            
            for (var po of row) {                
                var id = po[this.getIdProperty()]
                var item = this.view?.getItemById?.(id)
                if (item) {
                    item.AdjFg = this._AdjFg;
                    this.view.updateItem(id, item)
                }
            }
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }
        

    }
}

